import React, { useEffect, useState } from "react";
import twofactorApi from "service/twofactorApi";
import scan_qrImage from "../../assets/images/scan_qr.jpg";
import otpImage from "../../assets/images/otp.jpg";
import loadingImage from "../../assets/images/loading.gif";
import { Cookies } from "react-cookie";
import { pushNotification } from "utils/notifications";

const TwoFactor = () => {
  const [qr, setQr] = useState(loadingImage);

  const [loading, setLoading] = useState(false);

  const cookies = new Cookies();

  let userName = cookies.get("userInfo1");

  userName = userName?.replace("username=", "");

  if (!userName) window.location.href =  "/dang-nhap.aspx";

  useEffect(() => {
    twofactorApi.generateQr(userName).then((response) => {
      const base64 = response.data;

      setQr(base64);
    });
  }, []);

  const [otp, setOtp] = useState("");

  const verify = () => {
    if (!otp) {
      pushNotification("Vui lòng nhập mã otp", "error", "TOP_CENTER", 2000);
      return;
    }

    setLoading(true);

    const payload = {
      otp: otp,
      userName: userName,
    };

    twofactorApi
      .verifyOtp(payload)
      .then((response) => {
        setLoading(false);
        if (response && response.data) {
          const isSuccess = response.data.isSuccess;

          const message = response.data.message;

          if (!isSuccess) {
            pushNotification(message, "error", "TOP_CENTER", 2000);

            return;
          }

          const token = response.data.token;

          const cookies = new Cookies();
          cookies.set("userInfo", `token="${token}"`, { path: "/" });
          cookies.remove("userInfo1", { path: "/" });
          window.location.href = "/trang-chu/no-phai-thu.aspx";
        } else {
          pushNotification(
            "Đã có lỗi xảy ra, hãy thử lại sau",
            "error",
            "TOP_CENTER",
            2000
          );
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const changeValueOtp = (event) => {
    const re = /^[0-9\b]+$/;

    if (event.target.value === "" || re.test(event.target.value)) {
      setOtp(event.target.value);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      verify();
    }
  };

  const backToLogin = () => {
    const cookies = new Cookies();
    cookies.remove("userInfo", { path: "/" });
    cookies.remove("userInfo1", { path: "/" });
    window.location.href = "/dang-nhap.aspx";
  };

  return (
    <div className="container" style={{ float: "none" }}>
      <p>Cài đặt Google Authentication để đăng nhập</p>
      <hr />
      <div>
        <div className="row">
          <div className="col-sm-6 col-lg-6 col-6">
            <div style={{ width: "100%" }}>
              <img
                src={qr}
                alt="QR Code"
                title="QR Code"
                width={150}
                height={150}
              />
            </div>
            <div className={"input-otp"}>
              <input
                id="txtCode"
                value={otp}
                placeholder="Nhập mã từ app"
                onChange={changeValueOtp}
                type="text"
                maxLength={6}
                onKeyDown={handleKeyDown}
              />
            </div>
            <button
              className="btn btn-success btn-block mt-1 btnOtp"
              onClick={verify}
              disabled={loading}
            >
              Nhập
            </button>
            <button
              className="btn btn-secondary btn-block mt-1 btnOtp"
              onClick={backToLogin}
            >
              Quay trang đăng nhập
            </button>
          </div>
          <div className="col-sm-6 col-lg-6 col-6">
            <p>Hướng dẫn cài đặt Google Authentication</p>
            <p>
              <u>
                B1: Tìm phần mềm trên Appstore (IOS) hoặc Google Play (Android){" "}
                <b>Google Authentication</b>
              </u>
            </p>
            <p>
              <u>B2: Scan Barcode</u>
            </p>
            <img
              id="scan_qr"
              src={scan_qrImage}
              alt="Image"
              title="Image"
              width={250}
              height={250}
            />
            <p>
              <u>
                B3: Nhập mã trên app khi đăng nhập vào hệ thống sau khi bạn đã
                cài đặt và bật <b>Google Authentication</b>
              </u>
            </p>
            <img
              id="scan_qr"
              src={otpImage}
              alt="Image"
              title="Image"
              width={250}
              height={100}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwoFactor;
